import Seo from './marketing/Seo'
import { trackEvent } from '../Analytics/trackEvent'
import {
  PHOTO_ALBUM_ANDROID_STORE_LINK,
  PHOTO_ALBUM_IOS_STORE_LINK,
} from './PhotoAlbumRedirect'
import logo from '../Assets/photo-album/logo.png'
import logoBlue from '../Assets/photo-album/logo-blue.png'
import heroImg from '../Assets/photo-album/hero-img.webp'
import hearts from '../Assets/photo-album/hearts.png'
import stars from '../Assets/photo-album/stars.png'
import appStore from '../Assets/photo-album/AppStore.png'
import playStore from '../Assets/photo-album/PlayStore.png'
import guestsIcon from '../Assets/photo-album/guests.png'
import collectIcon from '../Assets/photo-album/collect.png'
import organiseIcon from '../Assets/photo-album/organise.png'
import reliveIcon from '../Assets/photo-album/relive.png'
import './PhotoAlbumLandingPage.css'

const FEATURES = [
  {
    icon: guestsIcon,
    alt: 'Hand holding a phone with a QR code',
    copy: <>Guests scan your QR<br />& upload their photos</>,
  },
  {
    icon: collectIcon,
    alt: 'Phone showing two smiling guests',
    copy: <>Collect photos & personal<br />messages from your guests</>,
  },
  {
    icon: organiseIcon,
    alt: 'Person taking a photo',
    copy: <>Organise photos into<br />albums & chapters</>,
  },
  {
    icon: reliveIcon,
    alt: 'Wedding album with overlapping hearts',
    copy: <>Relive it all in your<br />digital wedding album</>,
  },
]

function StoreBadges() {
  return (
    <div className="pa-badges">
      <a
        href={PHOTO_ALBUM_IOS_STORE_LINK}
        target="_blank"
        rel="noreferrer"
        onClick={() => trackEvent('photo_album_app_store_click', { platform: 'ios' })}
      >
        <img src={appStore} alt="Download on the App Store" />
      </a>
      <a
        href={PHOTO_ALBUM_ANDROID_STORE_LINK}
        target="_blank"
        rel="noreferrer"
        onClick={() => trackEvent('photo_album_app_store_click', { platform: 'android' })}
      >
        <img src={playStore} alt="Get it on Google Play" />
      </a>
    </div>
  )
}

export default function PhotoAlbumLandingPage() {
  return (
    <div className="pa-landing">
      <Seo
        title="First Dance Photo Album"
        description="Your wedding photographer captures the big moments. Your guests capture everything in between. Download First Dance Photo Album."
        path="/photo-album"
      />

      <section className="pa-hero">
        <div className="pa-hero-inner">
          <div className="pa-left">
            <img className="pa-logo" src={logo} alt="First Dance" />
            <div className="pa-copy">
              <p>Your wedding photographer<br />captures the big moments...</p>
              <p>Your guests capture<br />everything in between!</p>
            </div>
          </div>

          <div className="pa-collage">
            <img
              className="pa-collage-img"
              src={heroImg}
              alt="Polaroid collage of wedding photos"
            />
            <img className="pa-hearts" src={hearts} alt="" />
            <img className="pa-stars" src={stars} alt="" />
          </div>
        </div>
      </section>

      <section className="pa-download">
        <p className="pa-download-kicker">Available to download now</p>
        <StoreBadges />
      </section>

      <section className="pa-features">
        <div className="pa-features-panel">
          <h2>
            Collect your wedding guests photos &amp;{' '}
            <br />
            messages with one simple QR code
          </h2>
          <div className="pa-features-grid">
            {FEATURES.map((feature) => (
              <div className="pa-feature" key={feature.alt}>
                <img src={feature.icon} alt={feature.alt} />
                <p>{feature.copy}</p>
              </div>
            ))}
          </div>
          <p className="pa-features-tagline">Download, share &amp; keep forever</p>
        </div>
      </section>

      <footer className="pa-footer">
        <div className="pa-footer-inner">
          <div className="pa-footer-stores">
            <p className="pa-footer-kicker">Download now</p>
            <StoreBadges />
          </div>
          <img className="pa-footer-logo" src={logoBlue} alt="First Dance" />
        </div>
      </footer>
    </div>
  )
}
